export default "__VITE_ASSET__NyvTcEQk__"